import { useMemo, useCallback } from "react";
import { Material } from "@/types/material/material.types";
import { FilterOption } from "@/components/ui/table-header/types";

interface UseMaterialFiltersProps {
    materials: Material[];
    searchTerm: string;
    nameFilters: string[];
}

export const useMaterialFilters = ({
    materials,
    searchTerm,
    nameFilters,
}: UseMaterialFiltersProps) => {
    const filteredMaterials = useMemo(() => {
        if (!materials || materials.length === 0) return [];

        return materials.filter((material) => {
            // Filter by search term
            if (searchTerm && !material.name?.toLowerCase().includes(searchTerm.toLowerCase())) {
                return false;
            }

            // Filter by name filters
            if (nameFilters.length > 0 && !nameFilters.includes(material.name)) {
                return false;
            }

            return true;
        });
    }, [materials, searchTerm, nameFilters]);

    const getUniqueOptions = useCallback(
        (field: keyof Material): FilterOption[] => {
            if (!materials || materials.length === 0) return [];

            const uniqueValues = new Set<string>();

            materials.forEach((material) => {
                if (field === "name" && material.name) {
                    uniqueValues.add(material.name);
                }
            });

            return Array.from(uniqueValues)
                .sort()
                .map((value) => ({
                    label: value,
                    value: value,
                }));
        },
        [materials]
    );

    return {
        filteredMaterials,
        getUniqueOptions,
    };
}; 